import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import { loadCategoryData } from "@/api/api";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import PhotoCard from "@/components/common/PhotoCard";
// import JCategorySelect from "@comp/jeecg/JCategorySelect";
import { filterMultiDictText } from "@comp/jeecg/JDictSelectUtil";
import "@/assets/less/animation.css";
export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag: JDictSelectTag,
    PhotoCard: PhotoCard
    // JCategorySelect,
  },
  data: function data() {
    return {
      dataSourceTop: [],
      dataSource: [],
      pagination: {
        onChange: function onChange(page) {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      videoVisible: false,
      currentItem: {},
      queryParam: {
        column: 'createTime',
        order: 'desc',
        pageSize: 999
      },
      dictOptions: {}
    };
  },
  created: function created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (this.$route.query.type) {
      this.queryParam.eventType = this.$route.query.type;
    }
    this.getTopList();
    this.getList();
    // loadCategoryData({ code: "A05" }).then((res) => {
    //   if (res.success) {
    //     this.$set(this.dictOptions, "eventCategory", res.result);
    //   }
    // });
  },
  mounted: function mounted() {},
  methods: {
    getTopList: function getTopList() {
      var _this = this;
      this.dataSourceTop = [];
      this.queryParam.eventStatusList = '2';
      this.queryParam.pageNo = 1;
      this.queryParam.pageSize = 3;
      var formData = Object.assign({}, this.queryParam);
      getAction("/teaching/teachingEvent/getAvailableEvent", formData).then(function (res) {
        console.log(res);
        if (res.success) {
          _this.dataSourceTop = res.result.records;
        }
        _this.loading = false;
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      this.dataSource = [];
      this.queryParam.pageNo = 1;
      this.queryParam.pageSize = 999;
      this.queryParam.eventStatusList = '-1,0,1';
      var formData = Object.assign({}, this.queryParam);
      getAction("/teaching/teachingEvent/getAvailableEvent", formData).then(function (res) {
        console.log(res);
        if (res.success) {
          _this2.dataSource = res.result.records;
        }
        _this2.loading = false;
      });
    },
    isBigCover: function isBigCover(record) {
      if (record.showConfig) {
        console.log(record.showConfig);
        var showConfig = JSON.parse(record.showConfig);
        return showConfig.bigCover == undefined ? true : showConfig.bigCover;
      } else {
        return true;
      }
    },
    eventChange: function eventChange(v) {
      this.queryParam.eventId = v.target.value;
      this.getList();
    },
    onEventCategory: function onEventCategory(v) {
      this.queryParam.eventCategory = v;
      this.getList();
    },
    getDictValue: function getDictValue(text) {
      return text ? filterMultiDictText(this.dictOptions["eventCategory"], text) : "";
    },
    toDetail: function toDetail(item) {
      var route = this.$router.resolve({
        path: "/event/detail",
        query: {
          id: item.id
        }
      });
      window.open(route.href, "_blank");
    }
  }
};